import React, { createContext, useReducer, useContext } from "react";

import Wizard from "../Wizard";
import { WizardContext } from "../Wizard";

import StepOne from "./Steps/StepOne";
import StepTwo from "./Steps/StepTwo";
import StepThree from "./Steps/StepThree";
import StepFour from "./Steps/StepFour";
import StepFive from "./Steps/StepFive";
import StepSix from "./Steps/StepSix";
import Resume from "./Resume";
import reducer from "./reducer";
import { Container } from "./styles";

export const AnswerContext = createContext();

const steps = [
  {
    listOfItemsSideBar: [
      {
        title: "Dica",
        Content: () => (
          <>
            <p>Exemplos:</p>
            <ul>
              <li>- Escolha o seus ingredientes</li>
              <li>- Escolha os adicionais</li>
              <li>- Escolha o seu acompanhamento</li>
              <li>- Qual sabor você deseja?</li>
              <li>- Qual tamanho você deseja?</li>
              <li>- Qual pão você deseja?</li>
            </ul>
          </>
        ),
      },
      {
        title: "Resumo",
        Content: Resume,
      },
    ],
    title: "Descreva brevemente a sua pergunta",
    subTitle: "",
    Content: StepOne,
    isComplete: false,
  },
  {
    listOfItemsSideBar: [
      {
        title: "Dica",
        Content: () => (
          <>
            <p>
              Escreva como você quer que apareça no detalhe. <br />
              Ex: Se você perguntou: Qual tipo de pão você prefere? No detalhe
              aparecerá:
              <br />- Ingrediente: Nutella
            </p>
            <p>Outros Exemplos:</p>
            <ul>
              <li>- Ingrediente</li>
              <li>- Adicional</li>
              <li>- Tamanho</li>
              <li>- Sabor</li>
            </ul>
          </>
        ),
      },
      {
        title: "Resumo",
        Content: Resume,
      },
    ],
    title: "Qual a descrição que deverá aparecer do detalhe do pedido?",
    subTitle: "",
    Content: StepTwo,
    isComplete: false,
  },
  {
    listOfItemsSideBar: [
      {
        title: "Dica",
        Content: () => (
          <>
            <p>
              Se for marcado como obrigatório, o cliente deverá escolher uma das
              opções para conseguir adicionar o produto na cesta.
            </p>
          </>
        ),
      },
      {
        title: "Resumo",
        Content: Resume,
      },
    ],
    title: "É obrigatório?",
    subTitle: "",
    Content: StepThree,
    isComplete: false,
  },
  {
    listOfItemsSideBar: [
      {
        title: "Dica",
        Content: () => (
          <>
            <p>Adicione as opções que o seu cliente deverá escolher.</p>
            <p>
              Passe o mouse sobre os itens para poder <strong>alterar</strong>,{" "}
              <strong>remover</strong> ou <strong>reordenar</strong>.{" "}
            </p>
          </>
        ),
      },
      {
        title: "Resumo",
        Content: Resume,
      },
    ],
    title: "Adicione os itens que o cliente pode escolher",
    subTitle: "",
    Content: StepFour,
    isComplete: false,
  },
  {
    listOfItemsSideBar: [
      {
        title: "Resumo",
        Content: Resume,
      },
    ],
    title: "Quantas opções o cliente pode escolher?",
    subTitle: "",
    Content: StepFive,
    isComplete: true,
  },
];

const isManager = JSON.parse(localStorage.getItem(`isManager`) || false);
if (isManager) {
  steps.push({
    listOfItemsSideBar: [
      {
        title: "Resumo",
        Content: Resume,
      },
    ],
    title: "Se for Pizza Meio a Meio, Preço Cheio pela Maior?",
    subTitle: "",
    Content: StepSix,
    isComplete: true,
  });
}

function CreateAnswer({
  initialState,
  title = "Criando uma nova Pergunta",
  onDone = () => {},
  onClose = () => {},
}) {
  const [state, dispatch] = useReducer(reducer, {
    fullPrice: false,
    isActive: true,
    itens: [],
    max: 1,
    min: 1,
    multiple: false,
    name: "",
    nameShow: "",
    pictures: [],
    pricing: "default",
    required: null,
    inEditing: {
      status: false,
      index: 1,
      price: "",
      printDescription: "",
      details: "",
    },
    ...initialState,
  });

  return (
    <AnswerContext.Provider value={{ state, dispatch, WizardContext }}>
      <Container>
        <Wizard
          title={title}
          listOfSteps={steps}
          onDone={() => onDone(state)}
          onClose={onClose}
        />
      </Container>
    </AnswerContext.Provider>
  );
}

export default CreateAnswer;
